import { Layout, UserLogin as UserLoginComponent } from "components"
export const UserLogin = () => {
 return (
  <Layout>
   <UserLoginComponent />
  </Layout>
 )
}
